import React, { useEffect, useState } from 'react';
import './AdminPanel.css';
import roomTypes from './data/roomTypes';
import AdminForm from './AdminForm'; // adjust path if needed
import {
  Box, Button, Dialog, DialogTitle, DialogContent, TextField,
  DialogActions, Paper, IconButton
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Pencil, Trash2 } from 'lucide-react';

const apiURL = process.env.REACT_APP_API_URL || 'http://localhost:7071';

function AdminPanel() {
  const [rates, setRates] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const propertyId = user?.propertyId?.id || user?.properties?.[0]?.propertyId?.id;
    fetch(`${apiURL}/api/rates?propertyId=${propertyId}`)
      .then(res => res.json())
      .then(data => setRates(data))
      .catch(err => console.error("Failed to fetch rates:", err));
  }, []);

  return (
    <div className="admin-panel">
      <h2>Admin Panel: Manage Rates & Availability</h2>
      
      <Button variant="contained" onClick={() => setOpenForm(true)} sx={{ mb: 2 }}>
        Add Rate
      </Button>
      <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="md" fullWidth>
        <DialogTitle>Add or Update Rate</DialogTitle>
        <DialogContent>
          <AdminForm onClose={() => setOpenForm(false)} setRates={setRates} />
        </DialogContent>
      </Dialog>
      
      <Box sx={{ mt: 4 }}>
       
        <TextField
          label="Search Room Type"
          variant="outlined"
          size="small"
          sx={{ mb: 2 }}
          fullWidth
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Box display="flex" gap={2} mb={2}>
          <TextField
            label="Start Date"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <TextField
            label="End Date"
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </Box>
        <Box sx={{ height: 500, width: '100%', mt: 2 }}>
          <DataGrid
            rows={rates
              .filter((r) =>
                r.roomType.toLowerCase().includes(search.toLowerCase()) &&
                (!startDate || new Date(r.date) >= new Date(startDate)) &&
                (!endDate || new Date(r.date) <= new Date(endDate))
              )
              .map((r, index) => ({
                id: index,
                roomType: r.roomType.charAt(0).toUpperCase() + r.roomType.slice(1),
                price: r.price,
                roomOnlyRate: r.roomOnlyRate,
                availability: r.availability,
                breakfastGuests: r.breakfastGuests,
                roomsToSell: r.roomsToSell,
                actions: r
              }))}
            columns={[
              { field: 'roomType', headerName: 'Room Type', flex: 1 },
              { field: 'price', headerName: 'Breakfast Rate', flex: 1 },
              { field: 'roomOnlyRate', headerName: 'Room Only Rate', flex: 1 },
              { field: 'availability', headerName: 'Availability', flex: 1 },
              { field: 'breakfastGuests', headerName: 'Breakfast Included', flex: 1 },
              { field: 'roomsToSell', headerName: 'Rooms to Sell', flex: 1 },
              {
                field: 'actions',
                headerName: 'Actions',
                sortable: false,
                filterable: false,
                renderCell: (params) => (
                  <Box display="flex" gap={1}>
                    <IconButton size="small" color="primary">
                      <Pencil size={16} />
                    </IconButton>
                    <IconButton size="small" color="error">
                      <Trash2 size={16} />
                    </IconButton>
                  </Box>
                ),
                flex: 1
              }
            ]}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
            sx={{ borderRadius: 2, boxShadow: 1 }}
          />
        </Box>
      </Box>
    </div>
  );
}

export default AdminPanel;
